// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4930":"9cd0f6c9","5515":"fbc6fe32","6606":"08a8cd59","7227":"9cd0f6c9","7878":"9cd0f6c9","9071":"954283a6"}[chunkId] + ".chunk.css";
};